import React, { useId } from 'react';
import PageTitleLayout from '../../uiKit/pageTitleLayout';
import Paragraph from '../../uiKit/typography/paragraph';

import NewsBlock from '../infoBlocks/newsBlock';
import PartnersBlock from '../infoBlocks/partnersEpicBlock';
import { useTranslation } from 'react-i18next';

import HeroBlock from '../heroBlock';
import { NavLink } from 'react-router-dom';
import GamesSlider from '../../components/gamesSlider';
import BuiltBlock from '../builtBlock';
import GameOfMonthBlock from '../gameOfMonthBlock';
import WhyEpicBlock from '../WhyEpicBlock';

export default React.memo(function MainPage() {
  const { t } = useTranslation('common');
  // const gamesBlockId = useId();

  // const scrollToGameBlock = () => {
  //   const block = document.getElementById(gamesBlockId);
  //   if (block) block.scrollIntoView({ behavior: 'smooth' });
  // };

  return (
    <>
      <HeroBlock showOverlay={false}
                 childWrapperClassName={'!items-start'}>
        <div className={'w-full h-full flex items-center justify-center'}>
          <PageTitleLayout title={t('titles.main_page')}
                           className={'w-10/12 max-w-4xl flex flex-col items-center text-center gap-4 md:gap-6'}>
            <Paragraph className={'!text-white md:w-2/3'}>
              {t('descriptions.main_page')}
            </Paragraph>
            <div className={'flex flex-col w-full md:w-fit gap-4 md:flex-row justify-around items-center box-border'}>
              <NavLink to={'/games'} className={'block w-full text-white'}>
                  <span
                    className={'block py-2 px-4 bg-white text-base overflow-hidden rounded-lg '}>
                    <span className={'relative text-black z-[1] select-none'}>
                      {t('buttons.our_games')}
                    </span>
                  </span>
              </NavLink>
              <NavLink to={'/contacts'} className={' w-full'}>
                  <span
                    className={'block py-2 px-4 text-white text-base overflow-hidden border border-white rounded-lg whitespace-nowrap'}>
                    <span className={'relative z-[1]'}>
                      {t('buttons.become_partner')}
                    </span>
                  </span>
              </NavLink>
            </div>
          </PageTitleLayout>
        </div>
      </HeroBlock>

      <GamesSlider slidesPerView={4} speed={20} containerClassName={''}
                   className={'[&>div]:gap-16'} />

      <div className={'w-full px-10 py-20 pt-20 flex flex-col items-center justify-center'}>
        <BuiltBlock />
      </div>

      <div className={'w-full px-10 py-20 md:pt-15'}>
        <GameOfMonthBlock />
      </div>

      <div className={'w-full px-10 py-20 pt-20 flex flex-col items-center justify-center'}>
        <WhyEpicBlock />
      </div>

      <PartnersBlock />

      {/*<div className={'w-full py-20 md:pt-32 md:py-0 flex flex-col items-center'}>*/}
      {/*  <GamingSolutionsBlock />*/}
      {/*</div>*/}

      {/*<div className={'w-full py-16 md:py-32 flex flex-col items-center'}>*/}
      {/*  <MechanicsBlock />*/}
      {/*</div>*/}

      {/*<UpcomingGameBlock />*/}

      {/*<div className={'w-full py-20 md:py-32 flex flex-col items-center'}>*/}
      {/*  <GamesBlock title={t('titles.our_games')} topOffset={10} />*/}
      {/*</div>*/}

      {/*<div className={'w-full py-20 md:py-32 flex flex-col items-center'}>*/}
      {/*  <FeaturesBlock />*/}
      {/*</div>*/}

      {/*<div className={'w-full py-20 md:pt-32 flex flex-col items-center'}>*/}
      {/*  <DashboardBlock />*/}
      {/*</div>*/}

      <div className={'w-full py-20 md:py-32 flex flex-col items-center'}>
        <NewsBlock />
      </div>

    </>
  );
})
